import { useState } from "react";
import { Navigate, useSearchParams } from "react-router";
import type { LoginCallbackResponse } from "@klantpunt/shared";
import { Logo } from "../app/Logo";
import { ParentCompany } from "../app/ParentCompany";
import { api, ApiError } from "../lib/api";

/**
 * Landingspagina van de inloglink uit de mail. Logt pas in na een klik op de knop: mailscanners en
 * click-tracking openen links vooraf, en zouden de eenmalige link anders opmaken.
 */
export function LoginLinkPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!token) return <Navigate to="/inloggen?fout=verlopen" replace />;

  async function login() {
    setBusy(true);
    try {
      const res = await api<LoginCallbackResponse>("/auth/callback", { method: "POST", body: { token } });
      // Volledige navigatie, zodat de app opnieuw start met de nieuwe sessie.
      window.location.replace(res.redirect);
    } catch (err) {
      if (err instanceof ApiError && (err.code === "verlopen" || err.code === "geen-toegang")) {
        window.location.replace(`/inloggen?fout=${err.code}`);
        return;
      }
      setError(err instanceof Error ? err.message : "Inloggen is mislukt. Probeer het opnieuw.");
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="card">
        <Logo />
        <h1 className="dot">Inloggen</h1>
        <p className="muted">Klik op de knop om in te loggen bij Klantpunt.</p>
        {error && (
          <div className="alert" role="alert">
            {error}
          </div>
        )}
        <button type="button" className="btn primary block" onClick={login} disabled={busy}>
          Inloggen
        </button>
      </div>
      <ParentCompany />
    </div>
  );
}
